import React from 'react'
import styles from './ManageEachStaffAttendance.module.css'

const ManageEachStaffAttendance = () => {
    return (
        <div>ManageEachStaffAttendance</div>
    )
}

export default ManageEachStaffAttendance